<div class="nav primaryColorBG flex gap-8 justify-start content-center">
  @let showAdditionalBarElements = !showOmnisearch || innerWidth > 600;

  @if (showAdditionalBarElements) {
    <app-txp-logo data-test-id="txp-logo" (click)="navigateRoot()">
    </app-txp-logo>
  }

  @if (showOmnisearch && isOmnisearchAuthorised) {
    <app-omnisearch class="omnisearch"> </app-omnisearch>
  }

  @if (showAdditionalBarElements) {
    <div class="right-nav-elements">
      @if (isOmnisearchAuthorised && !showOmnisearch) {
        <button mat-icon-button (click)="showOmni()">
          <mat-icon>search</mat-icon>
        </button>
      }

      <app-timezone-input
        class="timezone-selector"
        testId="top-bar-timezone-selector"
        [timezone]="timezonePreferenceService.selectedTimezone()"
        (timezoneChange)="
          timezonePreferenceService.selectedTimezone.set($event)
        "
      />

      <button
        mat-icon-button
        data-test-id="top-bar-user-menu-button"
        [matMenuTriggerFor]="authMenu"
      >
        <mat-icon>person</mat-icon>
      </button>

      <mat-menu #authMenu="matMenu">
        @if (loggedInUser) {
          <div class="top-portion">
            <div class="icon-edit-container">
              <div
                class="profile-icon primaryColorBG"
                data-test-id="top-bar-user-menu-logged-in-user-initials"
              >
                {{ loggedInUser.first_name[0] | uppercase
                }}{{ loggedInUser.last_name[0] | uppercase }}
              </div>
            </div>
            <div
              class="name"
              data-test-id="top-bar-user-menu-logged-in-user-welcome-message"
              [attr.user-id]="loggedInUser.user_id"
            >
              Hi {{ loggedInUser.first_name }}
            </div>
          </div>
        }

        <button
          mat-menu-item
          appPortalNewLink
          data-test-id="top-bar-user-menu-new"
        >
          <mat-icon>rocket_launch</mat-icon>
          <span data-test-id="top-bar-user-menu-new-label">What's New</span>
        </button>

        @if (showReportsItem) {
          <button
            mat-menu-item
            data-test-id="top-bar-user-menu-reports"
            [routerLink]="['/reports']"
          >
            <mat-icon>summarize</mat-icon>
            <span data-test-id="top-bar-user-menu-reports-label"
              >Usage Reports</span
            >
          </button>
        }

        <button
          mat-menu-item
          appPortalFAQLink
          data-test-id="top-bar-user-menu-help"
        >
          <mat-icon>help_outline</mat-icon>
          <span data-test-id="top-bar-user-menu-help-label">Help</span>
        </button>

        <button
          mat-menu-item
          appPortalAiComplianceLink
          data-test-id="top-bar-user-ai-compliance"
        >
          <mat-icon>smart_toy</mat-icon>
          <span data-test-id="top-bar-user-ai-compliance-label">AI Policy</span>
        </button>

        <button
          mat-menu-item
          data-test-id="top-bar-user-menu-logout"
          (click)="logout()"
        >
          <mat-icon>logout</mat-icon>
          <span data-test-id="top-bar-user-menu-logout-label">Log Out</span>
        </button>
      </mat-menu>
    </div>
  }
</div>
